// VerificationDetails.js
import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Briefcase, Shield } from 'lucide-react';

const VerificationDetails = () => {
  const reportItems = [
 
    "Evidence Table: source/contact, method (call/email/visit), date/time, summary, artifacts",
    "Field Pack (addresses): photos, coordinates, timestamps, notes",
    "Quality Controls: case manager + supervisor names and sign-offs",
    "Tamper Control: document hash and QR code to verify authenticity"
  ];

  const useCases = [
    "Hiring & HR due diligence",
    "Tenant screening & estate management",
    "Customer onboarding & credit risk checks",
    "Visa, work, and study documentation (background evidence for Travel page)",
    "Partnerships and vendor vetting"
  ];

  const assurancePoints = [
    "Consent-first: we only proceed with proper permissions",
    "Privacy-safe: secure storage; retention limits explained at intake",
    "No bots, no scraping: every result is human-verified and auditable"
  ];

  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          
          {/* What your report includes */}
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <div className="flex items-start mb-6">
              <div className="w-12 h-12 bg-acYellow rounded-full flex items-center justify-center flex-shrink-0">
                <FileText className="w-6 h-6 text-white" />
              </div>
            </div>
            <h3 className="text-2xl font-inter font-bold text-acBlack mb-6">
              What your report includes
            </h3>
            <ul className="space-y-3">
              {reportItems.map((item, index) => (
                <li key={index} className="text-gray-600 leading-relaxed text-sm flex items-start">
                  <span className="mr-2 text-acYellow font-bold">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* When to use us */}
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="flex items-start mb-6">
              <div className="w-12 h-12 bg-acYellow rounded-full flex items-center justify-center flex-shrink-0">
                <Briefcase className="w-6 h-6 text-white" />
              </div>
            </div>
            <h3 className="text-2xl font-inter font-bold text-acBlack mb-6">
              When to use us
            </h3>
            <ul className="space-y-3">
              {useCases.map((item, index) => (
                <li key={index} className="text-gray-600 leading-relaxed text-sm flex items-start">
                  <span className="mr-2 text-acYellow font-bold">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Assurance & ethics */}
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <div className="flex items-start mb-6">
              <div className="w-12 h-12 bg-acYellow rounded-full flex items-center justify-center flex-shrink-0">
                <Shield className="w-6 h-6 text-white" />
              </div>
            </div>
            <h3 className="text-2xl font-inter font-bold text-acBlack mb-6">
              Assurance & ethics
            </h3>
            <ul className="space-y-3">
              {assurancePoints.map((item, index) => (
                <li key={index} className="text-gray-600 leading-relaxed text-sm flex items-start">
                  <span className="mr-2 text-acYellow font-bold">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default VerificationDetails;
